import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class MatchPlaylistDeleted extends DomainEvent<DeletedEntity> {}
